import { Content } from '@common/model/content';

export abstract class ContentFallbackServiceBase {
    abstract getContentFallback(): Content[];
}
